import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { UserCircle } from "lucide-react";
import PageHeader from "../../components/PageHeader";
import { getFreelancerProfile, updateFreelancerProfile } from "../../services/freelancer";

function Row({ label, value }) {
  return (
    <div className="flex justify-between border-b py-2 text-sm">
      <span className="text-gray-500">{label}</span>
      <span className="font-medium text-gray-800">{value || "—"}</span>
    </div>
  );
}

function FreelancerProfile() {
  const [p, setP] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getFreelancerProfile().then(setP);
  }, []);

  const toggleAvailable = async () => {
    setSaving(true);
    try {
      const updated = await updateFreelancerProfile({ isAvailable: !p.isAvailable });
      setP(updated);
      toast.success(updated.isAvailable ? "You're now available for work." : "You're marked unavailable.");
    } catch (e) {
      toast.error(e?.detail || e?.response?.data?.detail || "Update failed.");
    } finally {
      setSaving(false);
    }
  };

  if (!p) return <div className="p-6 text-gray-400">Loading…</div>;

  return (
    <div className="p-6 space-y-6">
      <PageHeader title="My Profile" subtitle="Freelancer account" icon={UserCircle} />
      <div className="max-w-xl rounded-lg border border-gray-200 bg-white p-6">
        <Row label="Name" value={p.name} />
        <Row label="Email" value={p.email} />
        <Row label="Mobile" value={p.mobile} />
        <div className="mt-4 flex items-center justify-between">
          <div>
            <div className="text-sm font-medium text-gray-800">Available for work</div>
            <div className="text-xs text-gray-500">Turn off to stop receiving new project offers.</div>
          </div>
          <button
            onClick={toggleAvailable}
            disabled={saving}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
              p.isAvailable ? "bg-emerald-500" : "bg-gray-300"
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                p.isAvailable ? "translate-x-6" : "translate-x-1"
              }`}
            />
          </button>
        </div>
      </div>
    </div>
  );
}

export default FreelancerProfile;
